import { call, put, takeLatest, all } from 'redux-saga/effects';
import { mediaService } from '../../services/mediaService';
import { MediaActionTypes } from '../actions/mediaActions';

function* fetchMediaData(action) {
  try {
    const { payload } = action;
    const { countries } = yield call(mediaService.fetchDistribution, payload);
    yield put({ type: MediaActionTypes.MEDIA_DATA_SUCCEEDED, countries });
  } catch (e) {
    yield put({ type: MediaActionTypes.MEDIA_DATA_FAILED, error: e });
  }
}

function* fetchTagsData(action) {
  try {
    const { payload } = action;
    const { countries } = yield call(mediaService.fetchTags, payload);
    yield put({ type: MediaActionTypes.TAGS_DATA_SUCCEEDED, countries });
  } catch (e) {
    yield put({ type: MediaActionTypes.TAGS_DATA_FAILED, error: e });
  }
}

function* generateUrl(action) {
  try {
    const { payload } = action;
    const url = yield call(
      mediaService.generateUrl.bind(mediaService),
      payload
    );
    yield put({ type: MediaActionTypes.GENERATE_URL_SUCCEEDED, url });
  } catch (e) {
    yield put({ type: MediaActionTypes.GENERATE_URL_FAILED, error: e });
  }
}

function* magazineRootSaga() {
  yield all([
    yield takeLatest(MediaActionTypes.MEDIA_DATA_REQUESTED, fetchMediaData),
    yield takeLatest(MediaActionTypes.TAGS_DATA_REQUESTED, fetchTagsData),
    yield takeLatest(MediaActionTypes.GENERATE_URL_REQUESTED, generateUrl)
  ]);
}

export default magazineRootSaga;



// WEBPACK FOOTER //
// ./src/redux/sagas/MediaSaga.js